import React from "react";
import clsx from "clsx";
import { createMemoClass } from "../create-memo-class";
import { usePaddingClasses } from "../shared-classes";
import { jsx as _jsx } from "react/jsx-runtime";
export var Text = _ref => {
  var {
    color = "inherit",
    align,
    padding,
    size = "md",
    children,
    className
  } = _ref;
  var classes = useTextClass({
    color,
    align,
    padding,
    size
  });
  return /*#__PURE__*/_jsx("article", {
    className: clsx(classes, className),
    children: children
  });
};
export var useTextClass = createMemoClass(props => {
  var aligns = {
    center: "text-center",
    left: "text-left",
    right: "text-right",
    inline: "inline"
  };
  var padding = usePaddingClasses(props.padding);
  var colors = {
    foreground: "text-foreground prose-headings:text-foreground prose-a:text-foreground prose-strong:text-foreground prose-em:text-foreground",
    inherit: "text-inherit prose-headings:text-inherit prose-a:text-inherit prose-strong:text-inherit prose-em:text-inherit"
  };
  var size = {
    "xl": "prose-lg md:prose-xl xl:prose-2xl",
    "lg": "prose-base md:prose-lg xl:prose-xl",
    "md": "prose-sm md:prose-base xl:prose-lg",
    "sm": "prose-sm md:prose-sm xl:prose-base"
  };
  var classes = clsx("prose max-w-full break-words", colors[props.color || "inherit"], aligns[props.align], padding, size[props.size] ? size[props.size] : size["md"]);
  return classes;
});
//# sourceMappingURL=text.js.map